exports.install = function (Vue, options) {
    Vue.prototype.msg = function(msg,type){
        this.$notify({
            title: '提示',
            message: msg,
            type: type?type:'warning'
        });
    };
};





// WEBPACK FOOTER //
// ./src/plugins/base.js